import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PageLoader from '../../../../components/PageLoader/PageLoader';
import PlanProcessBar from '../../../../components/ProcessBar/PlanProcessBar';
import InfoBox from '../../../../components/InfoBox/InfoBox';
import PolicyMember from './components/PolicyMember';
import { fetchPlanPolicy, createPlanPolicy } from './PolicyAction';
import { planIdSelector } from '../../../Dashboard/scenes/Plan/PlanSelectors';
import { planPolicyMembersSelector } from './PolicySelectors';

const PlanPolicy = ({ planId, planPolicyMembers, loading, fetchPlanPolicy, createPlanPolicy, planScreenTitle }) => {
  useEffect(() => {
    fetchPlanPolicy(planId);
  }, [planId, fetchPlanPolicy]);

  const addMember = async (memberContacts) => {
    const data = { contacts: memberContacts.map((obj) => obj.contactId) };
    await createPlanPolicy(planId, data);
  };

  return (
    <>
      <PlanProcessBar
        color="#5BC2E7"
        title={planScreenTitle || 'Business Continuity Policy Accountable Members'}
      />
      <InfoBox
        color="#5BC2E7"
        message="This area is used to compile data required to build your Business Continuity Policy"
      />
      <div className="component-wrapper">
        {!loading || planPolicyMembers ? (
          <PolicyMember
            color="#5BC2E7"
            title="Business Continuity Policy Accountable Members"
            members={planPolicyMembers}
            addMember={addMember}
          />
        ) : (
          <PageLoader />
        )}
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  planId: planIdSelector(state),
  planPolicyMembers: planPolicyMembersSelector(state),
  loading: state.policyReducer.loadingPlanPolicy
});

const mapDispatchToProps = { fetchPlanPolicy, createPlanPolicy };

export default connect(mapStateToProps, mapDispatchToProps)(PlanPolicy);
